module.exports = __webpack_public_path__ + "img/warn_02.4a1e968f.png";